import { styled } from "@mui/material/styles";
import ChooseFood from "assets/illustrations/chooseFoodImage.svg";
import ProcessingOrderImage from "assets/illustrations/processingOrderImage.svg";

// The refill drawer is copper from the door-open step on, and the order illustrations' green accents clash
// with it. The refill variants are the same drawings with those accents in the copper that the design's own
// copper illustrations use (startingUp, tutorial step 1). They are recoloured here instead of being copied:
// each SVG is 200–400 kB of path data inlined into the bundle.
const REFILL_ACCENT = "#C99272";

// `i`: match the fill attribute whatever case the SVG pipeline leaves the hex in.
const recolorAccent = (orderAccent: string) => ({
	[`& [fill="${orderAccent}" i]`]: { fill: REFILL_ACCENT },
});

export const RefillChooseFoodImage = styled(ChooseFood)(recolorAccent("#8BA08D"));
export const RefillProcessingImage = styled(ProcessingOrderImage)(recolorAccent("#80AB84"));
